module.exports = __webpack_public_path__ + "static/media/IMG_8978.412c5bd4.jpg";